/********
  * COMPONENT: USE THIS GLOBAL CONSTANT/FUNCTIONS TO MANAGE NEW ROLE CREATION.
  #. CONSTANT VARIABLES.
  #. TRANSLATED STRING OF LABELS.
  #. CURRENT USER ROLE INFORMATIONS.
  #. CURRENT USER INFORMATIONS.
  #. CURRENT CUSTOMER INFORMATIONS.
  #. CHECK MENUS ISENABLE.
  #. CHECK PAGES ISENABLE.
  #. CHECK COMPONENTS ISENABLE.
  #. TEST FUNCTIONS.
  #. PASSWORD VALIDATOR CHECK patternValidator()
  #. .... .... .... ....
  * @AUTHOR: IMPRESSICO(fb/gshukla67).
  * DATE: 02/02/2018.
  * UPDATE: --/--/----.
  */
import { Router, ActivatedRoute } from '@angular/router';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Environment } from 'environments/environment';
import * as _ from 'lodash';
import { EncryptionService } from './services/encryption.service';
export namespace Constants {

  var roleListObj = [], resourceListObj = [];
  var encryptionObj = new EncryptionService();
  export class Var {

    public static env = Environment.env;
    public static BASE_URL = Environment.apiBaseUrl;
    public static production = Environment.production;
    public static isMasterMockTrue = Environment.isMasterMockTrue;
    public static PAGINATION = 10;
    public static REPORT_PAGINATION = 25;
    public static DG_REPORT_PAGINATION = 50;
    public static dateFormate = 'yyyy-MM-dd';
    public static indiandateFormate = 'dd-MM-yyyy';
    public static isRequiredRefresh: boolean = false;
    public static timestampFormate = 'yyyy-MM-dd HH:mm';
    public static valMultiplyBy=2.2;
    public static tpaChildItems = [];
    public static shouldShowTpaReports: boolean;
    public dashboardGraphData: any;
    public static enumAgeGroup = [];
    public static sslOn: boolean= Environment.commProtocol;
    public static stompurl: boolean= Environment.commProtocol;
    public static QMS_BASE_URL = Environment.qmsBaseUrl;
    // public static get BASE_URL(): string { return Environment.apiBaseUrl; };

    constructor(
      private _router: Router,
      public _route: ActivatedRoute
    ) { }
  }

  export function CurrentBrandingDetails(key?: string): any {
    let brandingDetails = JSON.parse(localStorage.getItem('customerBrandingDetails'));
    if (!_.isEmpty(brandingDetails) && brandingDetails.brandingDetails != null) {
      if (key) {
        return brandingDetails.brandingDetails[key];
      } else {
        return brandingDetails.brandingDetails;
      }
    }
    return null;
  }

  export function Test(ev) {
    return "Hello... " + ev;
  }

  export function setBarchartData(val: any) {
    this.dashboardGraphData = {
      'label': val.label,
      'status': val.status
    }
  }

  export function getBarchartData() {
    return this.dashboardGraphData;
  }

  export function DisplayTranslatedString(key: string): any {
    let translateStr = JSON.parse(localStorage.getItem('translateStr') || null);
    if (translateStr) {
      return translateStr.tstring[key];
    } else {
      return null;
    }
  }

  export function ScoopUserRoleInformations(key: string): any {
    let authorizedRole = JSON.parse(localStorage.getItem('authorizedRole') || null);
    if (key) {
      return authorizedRole.role[key];
    }
    return authorizedRole.role;
  }

  export function userAuthorisedToken(): any {
    let currentUser = encryptionObj.getData('currentUser');
    if (currentUser && currentUser.token) {
      return currentUser.token;
    } else {
      return null
    }
  }

  export function CurrentUserFullInfo(): any {
    let currentUser = encryptionObj.getData('currentUser');
    return (currentUser != null && currentUser.user != null) ? currentUser.user : null;
  }

  export function CurrentUserInfomations(key?: string): any {
    let currentUser = encryptionObj.getData('currentUser');
    if (!_.isEmpty(currentUser) && currentUser.user != null) {
      if (key) {
        return currentUser.user[key];
      }
    }
    return null;
  }

  export function CurrentCustomerInfomations(key?: string): any {
    let currentCustomers = encryptionObj.getData('currentCustomer');
    if (!_.isEmpty(currentCustomers) && currentCustomers.customer != null) {
      if (key) {
        return currentCustomers.customer[key];
      } else {
        return currentCustomers.customer;
      }
    }
    return null;
  }
  
  // export function CurrentEnvironmentProperties(key?: string): any {
  //   let currentEnvironment = JSON.parse(localStorage.getItem('environmentSettings'));
  //   if (!_.isEmpty(currentEnvironment) && currentEnvironment.environmentSetting != null) {
  //     if (key) {
  //       return currentEnvironment.environmentSetting[key];
  //     } else {
  //       return currentEnvironment.environmentSetting;
  //     }
  //   }
  //   return null;
  // }


  export function CurrentEnvironmentProperties(key?: string): any {
    let currentEnvironment = JSON.parse(localStorage.getItem('environmentSettings'));
    if (!_.isEmpty(currentEnvironment) && currentEnvironment.environmentSetting != null) {
      if (key) {
        return currentEnvironment.environmentSetting[key];
      } else {
        return currentEnvironment.environmentSetting;
      }
    }
    return null;
  }

  export function CurrentAgeGroupEnum(key?: string): any {
    let currentAgeGroupEnum = JSON.parse(localStorage.getItem('ageGroupEnums'));
    if (!_.isEmpty(currentAgeGroupEnum) && currentAgeGroupEnum != null) {
      if (key) {
        return currentAgeGroupEnum[key];
      } else {
        return currentAgeGroupEnum;
      }
    }
    return null;
  }

  export function NotificationConfigKeysInformations(key?: string): any {
    let notificationKeysInformations = JSON.parse(localStorage.getItem('notificationKeys'));
    if (!_.isEmpty(notificationKeysInformations) && notificationKeysInformations.keys != null) {
      if (key) {
        return notificationKeysInformations.keys[key];
      } else {
        return notificationKeysInformations.keys;
      }
    }
    return null;
  }

  export function CurrentFirebaseInformations(key?: string): any {
    let firebaseInformations = JSON.parse(localStorage.getItem('firebaseInfo'));
    if (!_.isEmpty(firebaseInformations) && firebaseInformations.firebase != null) {
      if (key) {
        return firebaseInformations.firebase[key];
      } else {
        return firebaseInformations.firebase;
      }
    }
    return null;
  }

  export function CurrentConfigInformations(key?: string): any {
    let configInformations = JSON.parse(localStorage.getItem('appConfiguration'));
    if (!_.isEmpty(configInformations)) {
      if (key) {
        return configInformations.keys[key];
      } else {
        return configInformations.keys;
      }
    }
    return null;
  }

  export function resetFirebase(_firebase?: any): any {
    localStorage.removeItem('firebaseInfo');
    localStorage.setItem("firebaseInfo", JSON.stringify({ "firebase": _firebase }));
  }

  export function resetCostomerForPanasonicAdmin(customer: any): any {
    localStorage.removeItem('currentCustomer');
    if (!_.isEmpty(customer)) {
      encryptionObj.saveData('currentCustomer',{ customer: customer })
    } else {
      encryptionObj.saveData('currentCustomer',{ customer: null })
    }
  }

  export function LoadDependencyVariables(): void {
    this.resourceListObj = [];
    this.roleListObj = this.ScoopUserRoleInformations();
    _.forEach(this.roleListObj.resourceActionPairs, (res) => {
      this.resourceListObj.push(res.resourceName);
    });
    // console.log("UserResource: ", this.resourceListObj);
  }

  export function ObserveThePermission(resource: any): boolean {
    for (let key in resource) {
      if (this.resourceListObj.indexOf(resource[key]) > -1) {
        // console.log("Enabled: ", resource[key], this.resourceListObj.indexOf(resource[key]));
        return true;
      }
    }
    return false;
  }

  export function IsMenuEnable(path: string, resource: any): boolean {
    // if (!this.roleListObj) {
    this.LoadDependencyVariables();
    // }
    if (path == 'admin') {
      return this.ObserveThePermission(resource);
    }
    if (path == 'cms') {
      return this.ObserveThePermission(resource);
    }
    if (path == 'device') {
      return this.ObserveThePermission(resource);
    }
    if (path == 'list-customer') {
      return this.ObserveThePermission(resource);
    }
    // if (path == 'pending-approval-list-customer') {
    //   return this.ObserveThePermission(resource);
    // }
    if (path == 'list-roles') {
      return this.ObserveThePermission(resource);
    }
    if (path == 'list-user') {
      return this.ObserveThePermission(resource);
    }
    if (path == 'organization-settings') {
      return this.ObserveThePermission(resource);
    }
    if (path == 'media-library') {
      return this.ObserveThePermission(resource);
    }
    if (path == 'template') {
      return this.ObserveThePermission(resource);
    }
    if (path == 'campaign-list') {
      return this.ObserveThePermission(resource);
    }
    if (path == 'campaign-string-list') {
      return this.ObserveThePermission(resource);
    }
    if (path == 'planogram') {
      return this.ObserveThePermission(resource);
    }
    if (path == 'register-device') {
      return this.ObserveThePermission(resource);
    }
    if (path == 'device-info') {
      return this.ObserveThePermission(resource);
    }
    if (path == 'device-group') {
      return this.ObserveThePermission(resource);
    }
    if (path == 'devices-config') {
      return this.ObserveThePermission(resource);
    }
    if (path == 'reports') {
      return this.ObserveThePermission(resource);
    }
    if (path == 'list-onpremise' || path == 'premises') {
      return this.ObserveThePermission(resource);
    } if (path == 'tpa-list') {
      return this.ObserveThePermission(resource);
    }
    if (path == 'car-configurator') {
      return this.ObserveThePermission(resource);
    }
    if (path == 'tpa-reports') {
      return this.ObserveThePermission(resource);
    }
    if (path == 'resolution-list') {
      return this.ObserveThePermission(resource);
    }
    if (path == 'tpa-content-playback') {
      return this.ObserveThePermission(resource);
    }
    if (path == 'pdn-report') {
      return this.ObserveThePermission(resource);
    }
    if (path == 'demographic-dashboard') {
      return this.ObserveThePermission(resource);
    }
    if (path == 'dg-dashboard') {
      return this.ObserveThePermission(resource);
    }
    if (path == 'fa-reports') {
      return this.ObserveThePermission(resource);
    }    

  }

  export function IsPageEnable(resource: object): boolean {
    //if (!this.roleListObj) {
    this.LoadDependencyVariables();
    // }
    return this.ObserveThePermission(resource);
  }

  export function IsComponentEnable(resource: object): boolean {
    //if (!this.roleListObj) {
    this.LoadDependencyVariables();
    // }
    return this.ObserveThePermission(resource);
  }

  export function ScoopObjectPermission(resource: string, action: string): any {
    //if (!this.roleListObj) {

    this.LoadDependencyVariables();
    //  }
    for (let key in this.roleListObj.resourceActionPairs) {
      if (this.roleListObj.resourceActionPairs[key].resourceName == resource) {
        if (this.roleListObj.resourceActionPairs[key].actions.indexOf(action) >= 0) {
          return true;
        }
      }
    }
    return false;
  }

  export function ScopeResouceActions(resource: string): any {
    this.LoadDependencyVariables();
    for (let key in this.roleListObj.resourceActionPairs) {
      if (this.roleListObj.resourceActionPairs[key].resourceName == resource) {
        // if (this.roleListObj.resourceActionPairs[key].actions.indexOf(action) >= 0) {
          return this.roleListObj.resourceActionPairs[key].actions;
        // }
      }
    }
    return false;
  }
  export function setCmsForPanasonicMembers(uType: string, cms: string, cBoard: string, path: string, rList: Object): boolean {
    if (
      !_.isEmpty(this.CurrentUserInfomations(uType)) &&
      (this.CurrentUserInfomations(uType) == 'SUPER' || this.CurrentUserInfomations(uType) == 'CUST_REP_ADMIN')
    ) {
      if (!this.CurrentCustomerInfomations(cms)) {
        return true;
      }
      if (!this.CurrentCustomerInfomations(cBoard)) {
        return true;
      }
    } else {
      if (!this.CurrentCustomerInfomations(cBoard)) {
        return true;
      }
      if (!this.IsMenuEnable(path, rList)) {
        return true;
      }
    }
    return false;
  }

  export function setDeviceForPanasonicAdmin(cBoard: string, path: string, rList: Object): boolean {
    if (!this.CurrentCustomerInfomations(cBoard)) {
      return true;
    }
    if (!this.IsMenuEnable(path, rList)) {
      return true;
    }
    return false;
  }

  export function setParamsObject(_mObj: any = {}): string {
    if (!_.isEmpty(_mObj)) {
      const str: any = {};
      if (!_.isEmpty(_mObj.email)) {
        str.email = {
          "eq": _mObj.email
        }
      }
      if (!_.isEmpty(_mObj.fullName)) {
        str.fullname = {
          "eq": (_mObj.fullName)
        }
      }
      if (_mObj.locationAccess) {
        str.location_access = {
          "eq": (_mObj.locationAccess)
        }
      }
      if (!_.isEmpty(_mObj.role)) {
        str.role = {
          "eq": (_mObj.role)
        }
      }
      if (_mObj.createdFrom && _mObj.createdTo) {
        str.created_date = {
          "lte": (_mObj.createdTo),
          "gte": (_mObj.createdFrom)
        }
      }
      if (_mObj.licenceEndFromDate && _mObj.licenceEndToDate) {
        str.license_expiry_date = {
          "lte": (_mObj.licenceEndToDate),
          "gte": (_mObj.licenceEndFromDate)
        }
      }
      if (_mObj.status) {
        str.status = {
          "eq": (_mObj.status)
        }
      }
      if (_mObj.state && !_.isEmpty(_mObj.state)) {
        str.state = {
          "eq": (_mObj.state)
        }
      }
      if (_mObj.numberOfLicence != null) {
        let op: any;
        switch (_mObj.licenceOperators) {
          case '<':
            str.license_remaining = { lt: _.toNumber(_mObj.numberOfLicence) };
            break;
          case '>':
            str.license_remaining = { gt: _.toNumber(_mObj.numberOfLicence) };
            break;
          case '>=':
            str.license_remaining = { gte: _.toNumber(_mObj.numberOfLicence) };
            break;
          case '<=':
            str.license_remaining = { lte: _.toNumber(_mObj.numberOfLicence) };
            break;
          case '=':
            str.license_remaining = { eq: _.toNumber(_mObj.numberOfLicence) };
            break;
          default:
            // code...
            break;
        }
      }
      if (_mObj.cmsAccess) {
        str.cms_access = {
          "eq": (_mObj.cmsAccess == "true") ? true : false
        }
      }
      if (_mObj.fileSize >= 0) {
        switch (_mObj.licenceOperators) {
          case '<':
            str.file_size = { lt: _.toNumber(_mObj.fileSize) };
            break;
          case '>':
            str.file_size = { gt: _.toNumber(_mObj.fileSize) };
            break;
          case '>=':
            str.file_size = { gte: _.toNumber(_mObj.fileSize) };
            break;
          case '<=':
            str.file_size = { lte: _.toNumber(_mObj.fileSize) };
            break;
          case '=':
            str.file_size = { eq: _.toNumber(_mObj.fileSize) };
            break;
          default:
            // code...
            break;
        }
      }
      if (_mObj.uploadedBy) {
        str.uploaded_by = {
          "eq": (_mObj.uploadedBy)
        }
      }
      if (_mObj.mediaType) {
        str.content_type = {
          "eq": (_mObj.mediaType)
        }
      }
      if (_mObj.duration) {
        str.duration = {
          "gte": (_mObj.duration)
        }
      }

      if (_mObj.deviceStatus) {
        str.device_status = {
          "eq": (_mObj.deviceStatus)
        }
      }
      if (_mObj.panelStatus) {
        str.panel_status = {
          "eq": (_mObj.panelStatus)
        }
      }
      if (_mObj.deviceGroup) {
        str.device_group_id = {
          "eq": (_mObj.deviceGroup)
        }
      }
      if (_mObj.device_id) {
        str.device_id = {
          "eq": (_mObj.device_id)
        }
      }
      if (_mObj.location) {
        str.location = {
          "eq": (_mObj.location)
        }
      }

      if (_mObj.has_audio && !_.isEmpty(_mObj.has_audio)) {
        if (_mObj.has_audio == 1) {
          str.has_audio = {
            "eq": true
          }
        } else {
          str.has_audio = {
            "eq": false
          }
        }

      }
      if (_mObj.duration_in_seconds) {
        switch (_mObj.licenceOperatorsDuration) {
          case '<':
            str.duration_in_seconds = { lt: (_.toNumber(_mObj.duration_in_seconds)) ? _.toNumber(_mObj.duration_in_seconds) : 0 };
            break;
          case '>':
            str.duration_in_seconds = { gt: (_.toNumber(_mObj.duration_in_seconds)) ? _.toNumber(_mObj.duration_in_seconds) : 0 };
            break;
          case '>=':
            str.duration_in_seconds = { gte: (_.toNumber(_mObj.duration_in_seconds)) ? _.toNumber(_mObj.duration_in_seconds) : 0 };
            break;
          case '<=':
            str.duration_in_seconds = { lte: (_.toNumber(_mObj.duration_in_seconds)) ? _.toNumber(_mObj.duration_in_seconds) : 0 };
            break;
          case '=':
            str.duration_in_seconds = { eq: (_.toNumber(_mObj.duration_in_seconds)) ? _.toNumber(_mObj.duration_in_seconds) : 0 };
            break;
          default:
            // code...
            break;
        }
      }
      if (_mObj.number_of_regions) {
        switch (_mObj.licenceOperatorsRegions) {
          case '<':
            str.number_of_regions = { lt: (_.toNumber(_mObj.number_of_regions)) ? _.toNumber(_mObj.number_of_regions) : 0 };
            break;
          case '>':
            str.number_of_regions = { gt: (_.toNumber(_mObj.number_of_regions)) ? _.toNumber(_mObj.number_of_regions) : 0 };
            break;
          case '>=':
            str.number_of_regions = { gte: (_.toNumber(_mObj.number_of_regions)) ? _.toNumber(_mObj.number_of_regions) : 0 };
            break;
          case '<=':
            str.number_of_regions = { lte: (_.toNumber(_mObj.number_of_regions)) ? _.toNumber(_mObj.number_of_regions) : 0 };
            break;
          case '=':
            str.number_of_regions = { eq: (_.toNumber(_mObj.number_of_regions)) ? _.toNumber(_mObj.number_of_regions) : 0 };
            break;
          default:
            // code...
            break;
        }
      }
      if (_mObj.aspect_ratio && !_.isEmpty(_mObj.aspect_ratio)) {
        str.aspect_ratio = {
          "eq": (_mObj.aspect_ratio)
        }

      }
      if (_mObj.from_date) {
        str.from_date = {
          "eq": (_mObj.from_date)
        }
      }
      if (_mObj.to_date) {
        str.to_date = {
          "eq": (_mObj.to_date)
        }
      }
      if (_mObj.from_time) {
        str.from_time = {
          "eq": (_mObj.from_time)
        }
      }

      if (_mObj.to_time) {
        str.to_time = {
          "eq": (_mObj.to_time)
        }
      }
      if (_mObj.device) {
        str.device = {
          "in": (_.toNumber(_mObj.device))
        }
      }
      if (_mObj.user) {
        str.user = {
          "eq": (_.toNumber(_mObj.user))
        }
      }
      if (_mObj.module) {
        str.module = {
          "eq": (_mObj.module)
        }
      }
      if (_mObj.comments) {
        str.comments = {
          "lk": (_mObj.comments)
        }
      }
      if (_mObj.mediaDevice) {
        str.device = {
          "eq": (_.toNumber(_mObj.mediaDevice))
        }
      }
      if (_mObj.contentTag) {
        str.tag = {
          "eq": (_mObj.contentTag)
        }
      }
      if (_mObj.layoutTag) {
        str.layout_tag = {
          "eq": (_mObj.layoutTag)
        }
      }
      if (_mObj.customerType) {
        str.customerType = {
          "eq": (_mObj.customerType)
        }
      }
      if (_mObj.layoutId) {
        str.layoutId = {
          "eq": (_.toNumber(_mObj.layoutId))
        }
      }

      return "?q=" + encodeURIComponent(JSON.stringify(str));
    }
    return "";
  }

  export function getWidgetsSampleObject() {
    return WIDGETS;
  }

  export function resetVariables(makeEmptyRoleList: boolean = false): void {
    // this.resourceListObj = [];
    if (makeEmptyRoleList) this.roleListObj = null;
  }

  export function setParamsObjectForReports(_mObj: any = {}): string {
    if (!_.isEmpty(_mObj)) {
      const str: any = {};
      const strSort: any = {};
      if (!_.isEmpty(_mObj.role)) {
        str.role = {
          "eq": (_.toNumber(_mObj.role))
        }
      }
      if (_mObj.status) {
        str.status = {
          "eq": (_mObj.status)
        }
      }
      if (_mObj.uploadedBy) {
        str.uploaded_by = {
          "eq": (_mObj.uploadedBy)
        }
      }

      if (_mObj.device_id) {
        str.device_id = {
          "eq": (_mObj.device_id)
        }
      }
      if (_mObj.deviceGroupId) {
        str.deviceGroupId = {
          "in": (_mObj.deviceGroupId)
        }
      }
      if (_mObj.layoutId) {
        str.layoutId = {
          "eq": (_mObj.layoutId)
        }
      }
      if (_mObj.location) {
        str.location = {
          "eq": (_mObj.location)
        }
      }
      if (_mObj.from_date) {
        str.from_date = {
          "gte": (_mObj.from_date)
        }
      }
      if (_mObj.to_date) {
        str.to_date = {
          "lte": (_mObj.to_date)
        }
      }
      if (_mObj.device) {
        str.device = {
          "in": (_.toString(_mObj.device))
        }
      }
      if (_mObj.user) {
        str.user = {
          "eq": (_.toNumber(_mObj.user))
        }
      }
      if (_mObj.module) {
        str.module = {
          "eq": (_mObj.module)
        }
      }
      if (_mObj.comments) {
        str.comments = {
          "lk": (_mObj.comments)
        }
      }
      if (_mObj.mediaDevice) {
        str.device = {
          "in": (_.toString(_mObj.mediaDevice))
        }
      }
      if (_mObj.planogramName) {
        str.planogram = {
          "eq": (_.toNumber(_mObj.planogramName))
        }
      }
      if (_mObj.panelId) {
        str.panelId = {
          "eq": (_.toNumber(_mObj.panelId))
        }
      }
      if (_mObj.panelStatus) {
        str.panelStatus = {
          "eq": (_mObj.panelStatus)
        }
      }
      if (_mObj.planogramId) {
        str.planogramId = {
          "eq": (_.toNumber(_mObj.planogramId))
        }
      }
      if (_mObj.createdBy) {
        str.createdBy = {
          "eq": (_.toNumber(_mObj.createdBy))
        }
      }
      if (_mObj.approvedBy) {
        str.approvedBy = {
          "eq": (_.toNumber(_mObj.approvedBy))
        }
      }
      if (_mObj.deviceGroup) {
        str.deviceGroup = {
          "eq": (_.toNumber(_mObj.deviceGroup))
        }
      }
      if (_mObj.state) {
        str.state = {
          "eq": (_mObj.state)
        }
      }
      if (_mObj.deviceList) {
        str.device = {
          "in": (_mObj.deviceList)
        }
      }
      if (_mObj.gender) {
        str.gender = {
          "in": (_mObj.gender)
        }
      }
      if (_mObj.age) {
        str.age = {
          "in": (_mObj.age)
        }
      }
      if (_mObj.emotion) {
        str.emotion = {
          "in": (_mObj.emotion)
        }
      }
      if (_mObj.from_time) {
        str.from_time = {
          "gte": (_mObj.from_time)
        }
      }
      if (_mObj.to_time) {
        str.to_time = {
          "lte": (_mObj.to_time)
        }
      }
      if (_mObj.bandwidthInBytes) {
        switch (_mObj.range) {
          case '<':
            str.bandwidthInBytes = { lt: (_.toNumber(_mObj.bandwidthInBytes)) ? _.toNumber(_mObj.bandwidthInBytes) : 0 };
            break;
          case '>':
            str.bandwidthInBytes = { gt: (_.toNumber(_mObj.bandwidthInBytes)) ? _.toNumber(_mObj.bandwidthInBytes) : 0 };
            break;
          case '>=':
            str.bandwidthInBytes = { gte: (_.toNumber(_mObj.bandwidthInBytes)) ? _.toNumber(_mObj.bandwidthInBytes) : 0 };
            break;
          case '<=':
            str.bandwidthInBytes = { lte: (_.toNumber(_mObj.bandwidthInBytes)) ? _.toNumber(_mObj.bandwidthInBytes) : 0 };
            break;
          case '=':
            str.bandwidthInBytes = { eq: (_.toNumber(_mObj.bandwidthInBytes)) ? _.toNumber(_mObj.bandwidthInBytes) : 0 };
            break;
          default:
            // code...
            break;
        }
      }

      if (_mObj.sortBy && _mObj.sortType) {
        switch (_mObj.sortBy) {
          case 'userName':
            strSort.userName = _mObj.sortType;
            break;
          case 'date':
            strSort.date = _mObj.sortType;
            break;
          case 'module':
            strSort.module = _mObj.sortType;
            break;
          case 'action':
            strSort.action = _mObj.sortType;
            break;
          case 'duration':
            strSort.duration = _mObj.sortType;
            break;
          case 'deviceStatus':
            strSort.deviceStatus = _mObj.sortType;
            break;
          case 'locationName':
            strSort.locationName = _mObj.sortType;
            break;
          case 'deviceName':
            strSort.deviceName = _mObj.sortType;
            break;
          case 'emptySlotDuration':
            strSort.emptySlotDuration = _mObj.sortType;
            break;
          case 'deviceGroup':
            strSort.deviceGroup = _mObj.sortType;
            break;
          case 'entityId':
            strSort.entityId = _mObj.sortType;
            break;
          case 'entityName':
            strSort.entityName = _mObj.sortType;
            break;
          case 'planogramName':
            strSort.planogramName = _mObj.sortType;
            break;
          case 'campaignName':
            strSort.campaignName = _mObj.sortType;
            break;
          case 'contentName':
            strSort.contentName = _mObj.sortType;
            break;
          case 'deviceGroupName':
            strSort.deviceGroupName = _mObj.sortType;
            break;
          case 'numberOfFilesDownloaded':
            strSort.numberOfFilesDownloaded = _mObj.sortType;
            break;
          case 'downloadSizeInBytes':
            strSort.downloadSizeInBytes = _mObj.sortType;
            break;
          case 'downloadStatusInPercentage':
            strSort.downloadStatusInPercentage = _mObj.sortType;
            break;
          case 'panelName':
            strSort.panelName = _mObj.sortType;
            break;
          case 'panelStatus':
            strSort.panelStatus = _mObj.sortType;
            break;
          case 'contentType':
            strSort.contentType = _mObj.sortType;
            break;
          case 'isPlayed':
            strSort.isPlayed = _mObj.sortType;
            break;
          case 'planogramId':
            strSort.planogramId = _mObj.sortType;
            break;
          case 'createdOn':
            strSort.createdOn = _mObj.sortType;
            break;
          case 'priority':
            strSort.priority = _mObj.sortType;
            break;
          case 'customerName':
            strSort.customerName = _mObj.sortType;
            break;
          case 'bandwidthConsumed':
            strSort.bandwidthConsumed = _mObj.sortType;
            break;
          case 'createdByName':
            strSort.createdByName = _mObj.sortType;
            break;
          case 'approvedByName':
            strSort.approvedByName = _mObj.sortType;
            break;
          case 'startDate':
            strSort.startDate = _mObj.sortType;
            break;
          case 'endDate':
            strSort.endDate = _mObj.sortType;
            break;
          case 'state':
            strSort.state = _mObj.sortType;
            break;
          case 'scheduledPanelUpTime':
            strSort.scheduledPanelUpTime = _mObj.sortType;
            break;
          case 'onHrs':
            strSort.onHrs = _mObj.sortType;
            break;
          case 'offHrs':
            strSort.offHrs = _mObj.sortType;
            break;
          case 'onPercentage':
            strSort.onPercentage = _mObj.sortType;
            break;
          case 'offPercentage':
            strSort.offPercentage = _mObj.sortType;
            break;
          case 'scheduledPlayerUpTime':
            strSort.scheduledPlayerUpTime = _mObj.sortType;
            break;
          case 'tpAppName':
            strSort.tpAppName = _mObj.sortType;
            break;
          case 'upgradeOrDowngrade':
            strSort.upgradeOrDowngrade = _mObj.sortType;
            break;
          default:
            // code...
            break;
        }
      }
      if (_mObj.deviceStatus) {
        str.deviceStatus = {
          "eq": (_mObj.deviceStatus)
        }
      }
      if (_mObj.playbackStatus) {
        str.isPlayed = {
          "eq": (_mObj.playbackStatus)
        }
      }
      if (_mObj.tpAppId) {
        str.tpAppId = {
          "eq": (_mObj.tpAppId)
        }
      }
      if (_mObj.customerId) {
        str.customerId = {
          "in": (_mObj.customerId)
        }
      }
      if (_mObj.upgradeOrDowngrade) {
        str.upgradeOrDowngrade = {
          "eq": (_mObj.upgradeOrDowngrade)
        }
      }
      if (_mObj.deviceOne) {
        str.deviceOne = {
          "eq": (_mObj.deviceOne)
        }
      }
      if (_mObj.deviceTwo) {
        str.deviceTwo = {
          "eq": (_mObj.deviceTwo)
        }
      }
      if (_mObj.durationType) {
        str.durationType = {
          "eq": (_mObj.durationType)
        }
      }
      if (_mObj.layoutId) {
        str.layoutId = {
          "eq": (_.toNumber(_mObj.layoutId))
        }
      }


      let pagination = "";
      if (_mObj.pageNumber) {
        pagination = "&pageNumber=" + encodeURIComponent(_mObj.pageNumber);
      }
      if (_mObj.numPerPage) {
        pagination = pagination + "&numPerPage=" + encodeURIComponent(_mObj.numPerPage)
      }
      let reportToken = "";
      if (_mObj.reportToken) {
        reportToken = "&report-token=" + encodeURIComponent(_.toString(_mObj.reportToken));
      }
      let queryString = "";
      if (_.isEmpty(strSort) !== true && _.isEmpty(str) !== true) {
        queryString = "?q=" + encodeURIComponent(JSON.stringify(str)) + '&sort=' + encodeURIComponent(JSON.stringify(strSort)) + pagination + reportToken;
      } else if (_.isEmpty(strSort) === false && _.isEmpty(str) === true) {
        queryString = "?sort=" + encodeURIComponent(JSON.stringify(strSort)) + pagination + reportToken;
      }
      else if (_.isEmpty(strSort) === true && _.isEmpty(str) === false) {
        queryString = "?q=" + encodeURIComponent(JSON.stringify(str)) + pagination + reportToken;
      }
      return queryString;
    }
    return "";

  }

  export function PDNConfig(key?: string): any {
    let configInformations = JSON.parse(localStorage.getItem('PDNAccess'));
    if (!_.isEmpty(configInformations)) {
      if (key) {
        return configInformations.keys[key];
      } else {
        return configInformations.keys;
      }
    }
    return null;
  }


  export function patternValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        // if control is empty return no error
        return null;
      }

      // test the value of the control against the regexp supplied
      const valid = regex.test(control.value);

      // if true, return no error (no error), else return error passed in the second parameter
      return valid ? null : error;
    };
  }

  export const AgelabelsBgColor = [
    '#3da13e',
    '#95c560',
    '#d0db58',
    '#fa6541',
    '#fb9f39',
    '#fbc440',
    '#fce95c',
    '#5062b7',
    '#6585f6',
    '#6a3d9a',
    '#ffbd72',
    '#b15928',
    '#0ae8eb',
    '#6d8793',
    '#a340b4',
    '#b56bfc',
    '#c996fc',
    '#ff9895',
    '#ffff99',
    '#1b7cd5'
  ]
  
    export const age = [
      {"id":"0-5","itemName":"","itemText":"AGE_0_5"},
      {"id":"5-10","itemName":"5-10","itemText":"AGE_5_10"},
      {"id":"10-15","itemName":"10-15","itemText":"AGE_10_15"},
      {"id":"15-20","itemName":"15-20","itemText":"AGE_15_20"},
      {"id":"20-25","itemName":"20-25","itemText":"AGE_20_25"},
      {"id":"25-30","itemName":"25-30","itemText":"AGE_25_30"},
      {"id":"30-35","itemName":"30-35","itemText":"AGE_30_35"},
      {"id":"35-40","itemName":"35-40","itemText":"AGE_35_40"},
      {"id":"40-45","itemName":"40-45","itemText":"AGE_40_45"},
      {"id":"45-50","itemName":"45-50","itemText":"AGE_45_50"},
      {"id":"50-55","itemName":"50-55","itemText":"AGE_50_55"},
      {"id":"55-60","itemName":"55-60","itemText":"AGE_55_60"},
      {"id":"60-65","itemName":"60-65","itemText":"AGE_60_65"},
      {"id":"65-70","itemName":"65-70","itemText":"AGE_65_70"},
      {"id":"70-75","itemName":"70-75","itemText":"AGE_70_75"},
      {"id":"75-80","itemName":"75-80","itemText":"AGE_75_80"},
      {"id":"80-85","itemName":"80-85","itemText":"AGE_80_85"},
      {"id":"85-90","itemName":"85-90","itemText":"AGE_85_90"},
      {"id":"90-95","itemName":"90-95","itemText":"AGE_90_95"},
      {"id":"95-100","itemName":"95-100","itemText":"AGE_95_100"}
    ]
    
    export const gender = [
      {"id":"MALE","itemName":"MALE", "backgroundColor": "rgba(2,120,200,0.5)" },
      {"id":"FEMALE","itemName":"FEMALE", "backgroundColor": "rgba(255,192,203,0.8)"},
      {"id":"UNKNOWN","itemName":"UNKNOWN", "backgroundColor": "rgba(169,169,169,0.7)"},
      // {"id":"FEMALE_RATIO","itemName":"FEMALE RATIO", "backgroundColor": "#c1deb5"}
   ]
    
    export const emotion = [
      {"id":"HAPPY","itemName":"HAPPY", "backgroundColor": "#4aa23c"},
      {"id":"NO_DETECTION","itemName":"NO_DETECTION", "backgroundColor": "#cccccc"},
      {"id":"ANGER","itemName":"ANGER","backgroundColor": '#ea4335'},
      {"id":"DISGUSTING","itemName":"DISGUSTING", "backgroundColor": '#58e0e7'},
      {"id":"FEAR","itemName":"FEAR", "backgroundColor": '#fb9a99'},
      {"id":"NEUTRAL","itemName":"NEUTRAL", "backgroundColor": '#0278c8'},
      {"id":"SAD","itemName":"SAD", "backgroundColor": '#a6cee3'},
      {"id":"SURPRISE","itemName":"SURPRISE", "backgroundColor": '#f9c245'}
    ]

    export const frequency = [
      {"id":"HOURLY","itemName":"Hourly"},
      {"id":"DAILY","itemName":"Daily"},
      {"id":"WEEKLY","itemName":"Weekly"},
      {"id":"MONTHLY","itemName":"Monthly"}
    ]

  export function setStompConfig(key?:string):string{    
    let data = encryptionObj.getData('currentStompConfig');

    if (!_.isEmpty(data)) {
      if (key) {
        return data[key];
      } else {
        return data;
      }
    }
    return null;
  }
}



const WIDGETS = [{
  "contentId": null,
  "displayMode": "NORMAL",
  "orientation": "POTRAIT",
  "defaultDurationInSeconds": 5,
  "contentType": null,
  "widgetType": "CLOCK",
  "contentDescription": null,
  "createdBy": null,
  "createdOn": null,
  "modifiedOn": null,
  "status": 1,
  "access": "PUBLIC",
  "name": "Clock"
},
{
  "contentId": null,
  "displayMode": "NORMAL",
  "orientation": "POTRAIT",
  "defaultDurationInSeconds": 5,
  "contentType": null,
  "widgetType": "WEATHER",
  "contentDescription": null,
  "createdBy": null,
  "createdOn": null,
  "modifiedOn": null,
  "status": 1,
  "access": "PUBLIC",
  "name": "Weather"
},
{
  "contentId": null,
  "displayMode": "NORMAL",
  "orientation": "POTRAIT",
  "defaultDurationInSeconds": 5,
  "contentType": null,
  "widgetType": "CALENDAR",
  "contentDescription": null,
  "createdBy": null,
  "createdOn": null,
  "modifiedOn": null,
  "status": 1,
  "access": "PUBLIC",
  "name": "Calendar"
},
{
  "contentId": null,
  "displayMode": "NORMAL",
  "orientation": "POTRAIT",
  "defaultDurationInSeconds": 5,
  "contentType": null,
  "widgetType": "HDMI-IN",
  "contentDescription": null,
  "createdBy": null,
  "createdOn": null,
  "modifiedOn": null,
  "status": 1,
  "access": "PUBLIC",
  "name": "HDMI-IN"
}];


// WEBPACK FOOTER //
// ./src/app/app.constant.ts